<template>
  <div class="toolp_nav__payment">
    <h4>{{ text }}</h4>
  </div>
</template>

<script>
  export default {
    name: "NavPayment",
    props: {
      text: {
        type: String,
        default: ""
      }
    }
  };
</script>
